import React from 'react';
import PropTypes from 'prop-types';
import Provider from 'react-redux/es/components/Provider';
import ReactOnRails from 'react-on-rails';
import MainLayout from '../../containers/MainLayout/MainLayout';
import BreadCrumbs from '../../containers/BreadCrumbs/BreadCrumbs';
import DetailsRightPart from './DetailsRightPart/DetailsRightPart';
import MainSearch from '../../containers/MainSearch/MainSearch';
import DetailsLeftPart from '../../containers/DetailsLeftPart/DetailsLeftPart';
import './DetailsPageComponent.sass';

const DetailsPageComponent = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const {
    footerData,
    mapUrl,
  } = props;

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <div className="detailspage-container">
            <div className="grey-background">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <BreadCrumbs />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-9">
                    <DetailsLeftPart mapUrl={mapUrl} />
                  </div>

                  <div className="col-md-3">
                    <div className="rightContainer">
                      <DetailsRightPart />
                    </div>
                  </div>
                </div>
                <MainSearch />
              </div>
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

DetailsPageComponent.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

DetailsPageComponent.defaultProps = {
  footerData: {},
};

export default DetailsPageComponent;
